import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store/index";
import { useTranslation } from "react-i18next";

interface IProps {
    refreshButtonText?: string;
    onRefreshCallBack?: any;
    closeButtonText?: any;
    onCloseButtonCallBack: any;
}

const L3SystemErrorComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const onClose = () => {
        if (props.onCloseButtonCallBack != null) {
            props.onCloseButtonCallBack({ status: "success", data: "close" });
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h2 className="box-title">
                    <span className="dialog-icon status-default triangle-icon">
                        <em className="las la-exclamation-triangle"></em>
                    </span>
                        &nbsp; {tLang("dashboard.creditScore.l3SystemErrorComp.title")}
                </h2>
            </div>
            <div className="dialog-body">
                <div className="box-description">
                    <p>
                            {tLang("dashboard.creditScore.l3SystemErrorComp.l3-system-error-msg3")}
                        <br />{" "}
                    </p>
                    <p>
                        {" "}
                            {tLang("dashboard.creditScore.l3SystemErrorComp.l3-system-error-msg4")} <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a> {tLang("dashboard.creditScore.l3SystemErrorComp.l3-system-error-msg5")}
                    </p>
                </div>
            </div>
            {props.closeButtonText != null && (
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-primary" onClick={() => onClose()}>
                                <span className="btn-text">{props.closeButtonText}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default L3SystemErrorComponent;
